module.exports = __webpack_public_path__ + "media/images/flags/np-f6d8de219fef3980fedca335c14b24d0.svg";